import '../style/voiceButt.scss';

import {FunctionalComponent, h} from "preact";
import {useContext, useState} from "preact/hooks";
import {IcoVolumeMute, IcoVolumeUp} from "./icons";
import {EFFECTS, EffectsContext} from "../effects/effectsContext";
import {VoiceContext} from "../effects/voiceContext";
import {Loader} from "./loader";
import {LocalizationContext} from "../app";

//TODO upgrade to audiocontext the audioinstance
//https://stackoverflow.com/questions/879152/how-do-i-make-javascript-beep
export const VoiceButton: FunctionalComponent = () => {
  
  const effectsContext = useContext(EffectsContext);
  const voiceContext = useContext(VoiceContext);
  const { t } = useContext(LocalizationContext);

  function isVoiceActive(): boolean {

      const activeEffects = effectsContext.getEnabledEffects();
      for (const fx of activeEffects) {
          if (fx.type === EFFECTS.SPEAK) {
              return true;
          }
      }
      return false;
  }

  const [active, setActive] = useState(isVoiceActive());
  const [loading, setLoading] = useState(false);
  const [inited, setInit] = useState(false);
  
  function doSetActive(): void {
    effectsContext.enableEffect(EFFECTS.SPEAK);
    setLoading(false);
    setActive(true);
  }

  function toggle(): void {
      if (loading) return;
      
      if (isVoiceActive()) {
          effectsContext.disableEffect(EFFECTS.SPEAK);
          setActive(false);
          voiceContext.stop();
      } else {
        setLoading(true);
        if (!inited) {
          voiceContext.initSpeakOut().then(() => {
            setInit(true);
            doSetActive();
          }).catch(() => {
            // do nothing
          });
        } else {
          doSetActive();
        }
        
      }
  }

  return <button onClick={toggle} id="voiceBtn">
      {(!active && !loading) && <IcoVolumeMute />}
      { loading && <div className="loaderWrp"><Loader /></div>}
      {active && (<IcoVolumeUp />)}
  </button>;
}
